import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { Sort } from "@angular/material/sort";
import { PageScrollService, PageScrollInstance } from "ngx-page-scroll-core";
import { DOCUMENT } from "@angular/common";
import { AppConfig } from "./../../config";
import { ToastService } from "ng-uikit-pro-standard";
import { eventId } from "../../eventid";
import { getRequestID } from "../../requestid";

import { DataService } from "./../../data.service";
//import {MetaobjectViewService} from './metaobjectview.service';

@Component({
  selector: "app-metaobjectview",
  templateUrl: "./metaobjectview.component.html",
  styleUrls: ["./metaobjectview.component.scss"]
})
export class MetaobjectViewComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) set mscontent(ms: MatSort) {
    this.matSort = ms;
  }

  matSort: MatSort;
  metaobject: any;
  isLoading = false;
  isError = false;
  isDataLoaded = false;
  errorMessage = "";
  metaobjectId = "";
  objectName = "";
  modifiedby = "";
  modifieddate = "";
  objectAttributesDefnArr: any[];
  objectAttributeArray = [];

  detailForm = this.fb.group({
    label: "",
    name: new FormControl({ value: "", disabled: true }, Validators.required),
    pluralname: "",
    code: new FormControl({ value: "", disabled: true }, Validators.required),
    node: new FormControl({ value: "", disabled: true }),
    objecttype: "",
    category: "",
    description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    parentobject: "",
    embeddedobject: new FormControl({ value: false, disabled: true }),
    virtualobject: new FormControl({ value: false, disabled: true }),
    active: new FormControl({ value: true, disabled: true }),
    allowreports: new FormControl({ value: false, disabled: true }),
    allowactivities: new FormControl({ value: false, disabled: true }),
    trackfieldhistory: new FormControl({ value: false, disabled: true }),
    allowsearch: new FormControl({ value: false, disabled: true }),
    enablelicensing: new FormControl({ value: false, disabled: true }),
    allowworkflow: new FormControl({ value: false, disabled: true }),
    notesandattachments: new FormControl({ value: false, disabled: true }),
    allowqueuepublishing: new FormControl({ value: false, disabled: true }),
    alloweventpublish: new FormControl({ value: false, disabled: true }),
    mastertype: new FormControl({ value: false, disabled: true }),
    childtype: new FormControl({ value: false, disabled: true }),
    fieldvalidation: new FormControl({ value: false, disabled: true }),
    pathsetting: new FormControl({ value: false, disabled: true }),
    process: new FormControl({ value: false, disabled: true }),
    team: new FormControl({ value: false, disabled: true }),
    followup: new FormControl({ value: false, disabled: true }),
    linkobject: new FormControl({ value: false, disabled: true }),
    iconname: new FormControl({ value: false, disabled: true }),
    classification: new FormControl({ value: false, disabled: true }),
    redactiondefault: new FormControl({ value: false, disabled: true }),
    sortorder: new FormControl({ value: false, disabled: true }),
    auditmode: new FormControl({ value: false, disabled: true }),
    sinceversionseq: new FormControl({ value: false, disabled: true }),
    auditoutcome: new FormControl({ value: false, disabled: true }),
    deprecatedversionseq: new FormControl({ value: false, disabled: true }),
    system: new FormControl({ value: false, disabled: true }),
    licensable: new FormControl({ value: false, disabled: true }),
    auditable: new FormControl({ value: false, disabled: true })
  });

  attributeForm: FormGroup;
  attributeitems: FormArray;

  createItem(a: any, t: any, v: any, p = "", l: any): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p,
      label: l
    });
  }

  addAttributeItem(a: any, t: any, v: string | boolean, p = "", l: any): void {
    this.attributeitems = this.attributeForm.get("attributeitems") as FormArray;
    this.attributeitems.push(this.createItem(a, t, v, p, l));
  }

  resetDetailFormControls() {
    this.detailForm.controls["label"].setValue("");
    this.detailForm.controls["name"].setValue("");
    this.detailForm.controls["pluralname"].setValue("");
    this.detailForm.controls["code"].setValue("");
    this.detailForm.controls["node"].setValue("");
    this.detailForm.controls["objecttype"].setValue("");
    this.detailForm.controls["category"].setValue("");
    this.detailForm.controls["description"].setValue("");
    this.detailForm.controls["standard"].setValue(false);
    this.detailForm.controls["parentobjectid"].setValue("");
    this.detailForm.controls["parentobjectname"].setValue("");
    this.detailForm.controls["embeddedobject"].setValue(false);
    this.detailForm.controls["virtualobject"].setValue(false);
    this.detailForm.controls["active"].setValue(false);
    this.detailForm.controls["allowreports"].setValue(false);
    this.detailForm.controls["allowactivities"].setValue(false);
    this.detailForm.controls["trackfieldhistory"].setValue(false);
    this.detailForm.controls["allowsearch"].setValue(false);
    this.detailForm.controls["enablelicensing"].setValue(false);
    this.detailForm.controls["allowworkflow"].setValue(false);
    this.detailForm.controls["notesandattachments"].setValue(false);
    this.detailForm.controls["allowqueuepublishing"].setValue(false);
    this.detailForm.controls["alloweventpublish"].setValue(false);
    this.detailForm.controls["mastertype"].setValue(false);
    this.detailForm.controls["childtype"].setValue(false);
    this.detailForm.controls["fieldvalidation"].setValue(false);
    this.detailForm.controls["pathsetting"].setValue(false);
    this.detailForm.controls["process"].setValue(false);
    this.detailForm.controls["team"].setValue(false);
    this.detailForm.controls["followup"].setValue(false);
    this.detailForm.controls["linkobject"].setValue(false);

    this.detailForm.controls["iconname"].setValue(false);
    this.detailForm.controls["classification"].setValue("");
    this.detailForm.controls["redactiondefault"].setValue("");
    this.detailForm.controls["sortorder"].setValue("");
    this.detailForm.controls["auditmode"].setValue("");
    this.detailForm.controls["sinceversionseq"].setValue(0);
    this.detailForm.controls["auditoutcome"].setValue("");
    this.detailForm.controls["deprecatedversionseq"].setValue("");
    this.detailForm.controls["system"].setValue(false);
    this.detailForm.controls["licensable"].setValue(false);
    this.detailForm.controls["auditable"].setValue(false);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private appConfig: AppConfig,
    private pageScrollService: PageScrollService,
    private toastrService: ToastService,

    @Inject(DOCUMENT) private document: any
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.metaobjectId = this.route.snapshot.params.id;
      this.objectName = this.route.snapshot.params.objectname;
    });

    this.attributeForm = this.fb.group({
      objectid: "",
      name: "",
      attributeitems: this.fb.array([])
    });

    this.objectAttributesDefnArr = this.appConfig.objectAttributes;

    this.detailForm.controls.embeddedobject.disable();
    this.detailForm.controls.virtualobject.disable();
    this.detailForm.controls.active.disable();

    //load fields
    this.getMetaobjectById().then((res) => {
      console.log("response00000", res);
      this.isDataLoaded = true;

      this.pageScrollService.scroll({
        document: this.document,
        scrollTarget: ".buttons"
      });
    });
  }
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  // newCustomView() {
  //   this.router.navigateByUrl(
  //     "/home/customview/new/" +
  //       this.metaobjectId +
  //       "/" +
  //       this.objectName +
  //       "/" +
  //       "kijD000000UPXxR"
  //   );
  // }
  // localStorage.getItem("crm_profileid", userDetails.profileid);
  //  const profileid = localStorage.getItem("crm_profileid");

  newCustomView() {
    const profileId = localStorage.getItem("crm_profileid");

    this.router.navigateByUrl(
      "/home/customview/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        profileId
    );
  }

  editCustomView() {
    this.router.navigateByUrl(
      "/home/customview/edit/" +
        "id###" +
        "/" +
        "Lead_CustomView_Test_cv11" +
        "/" +
        "Test cv11" +
        "/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        "kijD000000UPXxR" +
        "/" +
        true
    );
  }
  // schemaRecalculate() {
  //   console.log("schemaRecalculate");
  //   var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
  //   const domain = localStorage.getItem(
  //     `${localStorage.getItem("crm_orgid")}.domain`
  //   );
  //   const subdomain = localStorage.getItem(
  //     `${localStorage.getItem("crm_orgid")}.subdomain`
  //   );
  //   let publish = {
  //     topic: `${domain}.metadata.module.created`,
  //     group_id: "metadata",
  //     message: [
  //       {
  //         current_context: {},
  //         context: {
  //           organizationid: localStorage.getItem("crm_orgid")
  //         },
  //         user: {
  //           user_name: localStorage.getItem("crm_loginid"),
  //           _id: localStorage.getItem("crm_userid"),
  //           name: localStorage.getItem("crm_username"),
  //           profile_id: userDetail.profileid,
  //           // "app_name": "ERP",
  //           // "language_code": "EN",
  //           // app_name: localStorage.getItem(
  //           //   `${localStorage.getItem("crm_orgid")}.subdomain`
  //           // )
  //           app_name: domain
  //         },

  //         domain: domain,
  //         subdomain: subdomain,
  //         action: {
  //           modulename: this.objectName,
  //           // "metalayoutname": "Enquiry_New",
  //           // "action_type": "New",
  //           query_id: "query_scherp_admin_enquiry_find",
  //           event_id: "evt_001"
  //         },
  //         relative_url: "api/v1/erp/meta/r/erpmeta/getwebpagelayout",
  //         request_id: "09eb36f4-2a05-45bb-afba-54c32c78ef3d",
  //         query: {}
  //       }
  //     ]
  //   };

  //   // this.dataService.metaobjectPublish(publish).subscribe();
  //   console.log("publish", publish);
  //   this.dataService.outboxeventPublish(publish).subscribe((res) => {
  //     console.log("publish res", res);
  //     this.showSuccess(res.message);
  //   });
  // }

  schemaRecalculate() {
    console.log("schemaRecalculate");

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    const orgId = localStorage.getItem("crm_orgid");

    const domain = localStorage.getItem(`${orgId}.domain`).toLowerCase();

    const subdomain = localStorage.getItem(`${orgId}.subdomain`);

    let publish = {
      topic: `${domain}.metadata.module.created`,
      group_id: "metadata",

      message: [
        {
          current_context: {},

          context: {
            organizationid: orgId
          },

          user: {
            user_name: localStorage.getItem("crm_loginid"),

            _id: localStorage.getItem("crm_userid"),

            name: localStorage.getItem("crm_username"),

            profile_id: userDetail.profileid,

            app_name: domain,
            org_code: localStorage.getItem(
              `${localStorage.getItem("crm_orgid")}.subdomain`
            )
          },

          domain: domain,

          subdomain: subdomain,

          action: {
            modulename: this.objectName,

            query_id: "query_scherp_admin_enquiry_find",

            event_id: "evt_001"
          },

          relative_url: "api/v1/erp/meta/r/erpmeta/getwebpagelayout",

          request_id: "09eb36f4-2a05-45bb-afba-54c32c78ef3d",

          query: {}
        }
      ]
    };

    console.log("publish payload", JSON.stringify(publish, null, 2));

    this.dataService.outboxeventPublish(publish).subscribe(
      (res) => {
        console.log("publish success", res);

        this.showSuccess(res.message);
      },
      (err) => {
        console.log("publish error", err);

        this.showError(err.error.message || "Publish failed");
      }
    );
  }

  // schemaRecalculate() {
  //   console.log("schemaRecalculate");

  //   var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

  //   const orgId = localStorage.getItem("crm_orgid");

  //   const domain = localStorage.getItem(`${orgId}.domain`).toLowerCase();

  //   const requestid = getRequestID();
  //   const subdomain = localStorage.getItem(`${orgId}.subdomain`);
  //   // const event_id = eventId("Metadata", this.objectName, "create");

  //   const event_id = eventId("Metadata", this.objectName, "create");
  //   let publish = {
  //     topic: `${domain}.metadata.module.created`,
  //     group_id: "metadata",

  //     message: [
  //       {
  //         current_context: {},

  //         context: {
  //           organizationid: orgId
  //         },

  //         user: {
  //           user_name: localStorage.getItem("crm_loginid"),

  //           _id: localStorage.getItem("crm_userid"),

  //           name: localStorage.getItem("crm_username"),

  //           app_name: domain
  //         },

  //         domain: domain,

  //         subdomain: subdomain,

  //         action: {
  //           modulename: this.objectName,
  //           event_id: event_id
  //         },

  //         // relative_url: "api/v1/turbo/c/metaobject",

  //         query: {}
  //       }
  //     ],
  //     relative_url: "api/v1/turbo/c/metaobject",

  //     request_id: requestid
  //   };

  //   console.log("publish payload", JSON.stringify(publish, null, 2));

  //   this.dataService.outboxeventPublish(publish).subscribe(
  //     (res) => {
  //       console.log("publish success", res);

  //       this.showSuccess(res.message);
  //     },
  //     (err) => {
  //       console.log("publish error", err);

  //       this.showError(err.error.message || "Publish failed");
  //     }
  //   );
  // }

  newField() {
    /*var qparams = {
      metaobjectid: this.metaobjectId,
      metaobjectname: this.objectName,
      parentobjectid: this.metaobject.parentobjectid,
      embeddedobject: this.metaobject.embeddedobject,
      virtualobject: this.metaobject.virtualobject,
    };
    //console.log("qparams",qparams);
    //this.router.navigate(['/home/metafield/new'], { queryParams: qparams });
    */
    //console.log("path", '/home/metafield/new/'+ this.metaobjectId + '/' + this.objectName + '/' + (this.metaobject.parentobjectid==''?'none': this.metaobject.parentobjectid) + '/' + this.metaobject.embeddedobject + '/' + this.metaobject.virtualobject);

    this.router.navigateByUrl(
      "/home/metafield/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        (this.metaobject.parentobjectid == ""
          ? "none"
          : this.metaobject.parentobjectid) +
        "/" +
        (this.metaobject.parentobjectname == ""
          ? "none"
          : this.metaobject.parentobjectname) +
        "/" +
        this.metaobject.embeddedobject +
        "/" +
        this.metaobject.virtualobject
    );
  }

  metaobjectList() {
    this.router.navigateByUrl("home/metaobjectlist");
  }

  editMetaobject() {
    this.router.navigateByUrl(
      "/home/metaobject/edit/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        this.metaobject.parentobjectid +
        "/" +
        +(this.metaobject.parentobjectname == ""
          ? "none"
          : this.metaobject.parentobjectname) +
        "/" +
        this.metaobject.embeddedobject +
        "/" +
        this.metaobject.virtualobject
    );
  }

  getMetaobjectById() {
    return new Promise((resolve, reject) => {
      console.log("getMetaobjectById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            id: this.metaobjectId
          }
        }
      };
      console.log(postOption);

      this.isLoading = true;
      this.dataService.getMetaobjectById(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metaobject = res.data.metaobject;
            if (this.metaobject != null) {
              const node = Object.keys(this.metaobject.nodemapping).join(",");

              this.detailForm.controls["label"].setValue(this.metaobject.label);
              this.detailForm.controls["name"].setValue(this.metaobject.name);
              this.detailForm.controls["pluralname"].setValue(
                this.metaobject.pluralname
              );
              this.detailForm.controls["code"].setValue(this.metaobject.code);
              // this.detailForm.controls["node"].setValue(
              //   this.metaobject.nodemapping
              // );
              this.detailForm.controls["node"].setValue(node);
              this.detailForm.controls["objecttype"].setValue(
                this.metaobject.objecttype
              );
              this.detailForm.controls["category"].setValue(
                this.metaobject.category
              );
              this.detailForm.controls["description"].setValue(
                this.metaobject.description
              );
              this.detailForm.controls["standard"].setValue(
                this.metaobject.standard
              );
              this.detailForm.controls["parentobjectid"].setValue(
                this.metaobject.parentobjectid
              );
              this.detailForm.controls["parentobjectname"].setValue(
                this.metaobject.parentobjectname
              );
              this.detailForm.controls["embeddedobject"].setValue(
                this.metaobject.embeddedobject
              );
              this.detailForm.controls["virtualobject"].setValue(
                this.metaobject.virtualobject
              );
              this.detailForm.controls["active"].setValue(
                this.metaobject.active
              );
              this.detailForm.controls["allowreports"].setValue(
                this.metaobject.allowreports
              );
              this.detailForm.controls["allowactivities"].setValue(
                this.metaobject.allowactivities
              );
              this.detailForm.controls["trackfieldhistory"].setValue(
                this.metaobject.trackfieldhistory
              );
              this.detailForm.controls["allowsearch"].setValue(
                this.metaobject.allowsearch
              );
              this.detailForm.controls["enablelicensing"].setValue(
                this.metaobject.enablelicensing
              );
              this.detailForm.controls["allowworkflow"].setValue(
                this.metaobject.allowworkflow
              );
              this.detailForm.controls["notesandattachments"].setValue(
                this.metaobject.notesandattachments
              );
              this.detailForm.controls["allowqueuepublishing"].setValue(
                this.metaobject.allowqueuepublishing
              );
              this.detailForm.controls["alloweventpublish"].setValue(
                this.metaobject.alloweventpublish
              );
              this.detailForm.controls["mastertype"].setValue(
                this.metaobject.mastertype
              );
              this.detailForm.controls["childtype"].setValue(
                this.metaobject.childtype
              );
              this.detailForm.controls["fieldvalidation"].setValue(
                this.metaobject.fieldvalidation
              );
              this.detailForm.controls["pathsetting"].setValue(
                this.metaobject.pathsetting
              );
              this.detailForm.controls["process"].setValue(
                this.metaobject.process
              );
              this.detailForm.controls["team"].setValue(this.metaobject.team);
              this.detailForm.controls["followup"].setValue(
                this.metaobject.followup
              );
              this.detailForm.controls["linkobject"].setValue(
                this.metaobject.linkobject
              );
              this.detailForm.controls["iconname"].setValue(
                this.metaobject.iconname
              );
              this.detailForm.controls["classification"].setValue(
                this.metaobject.classification
              );
              this.detailForm.controls["redactiondefault"].setValue(
                this.metaobject.redactiondefault
              );
              this.detailForm.controls["sortorder"].setValue(
                this.metaobject.sortorder
              );
              this.detailForm.controls["auditmode"].setValue(
                this.metaobject.auditmode
              );
              this.detailForm.controls["sinceversionseq"].setValue(
                this.metaobject.sinceversionseq != null
                  ? this.metaobject.sinceversionseq
                  : 0
              );
              this.detailForm.controls["auditoutcome"].setValue(
                this.metaobject.auditoutcome
              );
              this.detailForm.controls["deprecatedversionseq"].setValue(
                this.metaobject.deprecatedversionseq != null
                  ? this.metaobject.deprecatedversionseq
                  : 0
              );
              this.detailForm.controls["system"].setValue(
                this.metaobject.system
              );
              this.detailForm.controls["licensable"].setValue(
                this.metaobject.licensable
              );
              this.detailForm.controls["auditable"].setValue(
                this.metaobject.auditable
              );

              this.modifiedby = this.metaobject.modifiedby;
              this.modifieddate = this.metaobject.modifieddate;

              this.objectAttributeArray = this.objectAttributesDefnArr;
              console.log("attributes", this.objectAttributeArray);

              var fgArray = new Array<FormGroup>();
              //transform json to attribute form controls
              for (let i = 0; i < this.objectAttributeArray.length; i++) {
                var item = this.objectAttributeArray[i];

                //get value from the attributes
                var value = this.metaobject.attributes[item.attr];
                if (value instanceof Array) {
                  value = JSON.stringify(value);
                }
                // this.addAttributeItem(item.attr, item.type, value);
                // this.addAttributeItem(item.attr, item.type, "", "", item.label);
                if (item.type.toLocaleLowerCase() == "json") {
                  this.addAttributeItem(
                    item.attr,
                    item.type,
                    JSON.stringify(value) || "{}",
                    "",
                    item.label
                  );
                } else {
                  this.addAttributeItem(
                    item.attr,
                    item.type,
                    value,
                    "",
                    item.label
                  );
                }
              }
              console.log(
                "this.metaobject.embeddedobject",
                this.metaobject.embeddedobject
              );
            } else {
              this.errorMessage =
                "Data not found or must have been deleted by other user";
              this.isError = true;
              this.isLoading = false;
              this.resetDetailFormControls();
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            this.resetDetailFormControls();
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.resetDetailFormControls();
          resolve(null);
        }
      );
    });
  }
}
